(function() {
    'use strict';
    angular
        .module('nasracApp')
        .factory('Office', Office);

    Office.$inject = ['$resource'];

    function Office ($resource) {
        var resourceUrl =  'api/offices/:id';
        var xlsxContentType = 'application/octet-stream';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'download' : {
                method : 'GET',
                url : 'api/offices/download',
                headers: {
                    accept: xlsxContentType
                },
                responseType: 'arraybuffer',
                cache: false,
                transformResponse: function (data) {
                    return {
                        response: new Blob([data], {type: xlsxContentType})
                    };
                }
            },
            'delete' : {
                method : 'DELETE',
                url: 'api/offices/:id/:officeName'
            }
        });
    }
})();
